<template>
  <el-dialog :top="top"
             :width="width"
             :show-close="false"
             :visible.sync="visible"
             :close-on-click-modal="false"
             :class="{'esp_not_footer': !showFooter, 'esp_clear_padding': clearPadding}"
             v-loading="showLoading"
             class="esp_dialog_warp"
             append-to-body
             v-dialogDrag
             top="5vh"
             element-loading-background="rgba(255, 255, 255, 0.35)">
    <template slot="title">
      <span class="esp_dialog_title">{{ title }}</span>
      <i class="el-icon-full-screen esp_full_btn"></i>
      <i class="el-icon-close esp_close_btn" @click="visible = false"></i>
    </template>

    <el-scrollbar v-if="useScrollbar" class="esp_scrollbar">
      <slot></slot>
    </el-scrollbar>
    <slot v-else></slot>

    <template slot="footer" v-if="showFooter">
      <div :style="{textAlign: footerTextAlign}">
        <slot name="footer-left-button"></slot>
        <el-button type="primary" size="mini" @click="doAction()" v-if="showConfirm">{{ textConfirm }}</el-button>
        <el-button type="default" size="mini" @click="visible = false" v-if="showClose">{{ textCancel }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "EspElDialog",
  data() {
    return {
      visible: false,      // 弹框是否显示
      showLoading: false   // 显示加载框
    }
  },
  props: {
    title: {                // 弹框标题
      type: String,
      default: "对话框"
    },
    textConfirm: {
      type: String,
      default: "确定"
    },
    textCancel: {
      type: String,
      default: "取消"
    },
    showConfirm: {        // 是否显示确定按钮
      type: Boolean,
      default: true
    },
    showClose: {        // 是否显示确定按钮
      type: Boolean,
      default: true
    },
    width: {                // 弹框宽度
      type: String,
      default: "80%"
    },
    height: {               // 弹框高度
      type: String,
      default: "80%"
    },
    top: {                  // 弹框上下定位的距离
      type: String,
      default: "15vh"
    },
    footerTextAlign: {     // 底部按钮的位置
      type: String,
      default: 'center'
    },
    loading: {              // 是否显示加载框
      type: Boolean,
      default: false
    },
    fullScreen: {           // 是否显示全屏按钮
      type: Boolean,
      default: true
    },
    showFooter: {           // 是否显示底部的按钮
      type: Boolean,
      default: true
    },
    useScrollbar: {         // 是否使用滚动条
      type: Boolean,
      default: true
    },
    clearPadding: {         // 清除内边距
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 打开弹框
    opened: function () {
      this.visible = true;
    },

    // 点击 "确定" 按钮的事件
    doAction: function () {
      this.showLoading = true;

      this.$emit("doAction", result => {
        if (result == true) {
          this.visible = false;
        }
        this.showLoading = false;
      });
    }
  },
  watch: {
    height: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          let el = this.$el;
          let dialog = el.getElementsByClassName("el-dialog")[0];
          dialog.style.height = newVal;
        });
      },
      immediate: true
    },
    loading: {
      handler(newVal, oldVal) {
        this.showLoading = newVal;
      },
      immediate: true
    }
  }
}
</script>

<style lang="less">
.esp_dialog_warp {
  .el-dialog {

    .el-dialog__header {
      height: 34px;
      line-height: 34px;
      padding: 5px 10px;
      position: relative;
      box-sizing: border-box;
      background-color: #f5f5f5;

      .esp_dialog_title {
        font-size: 13px;
        font-weight: 600;
        display: block;
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
      }

      .esp_full_btn,
      .esp_close_btn {
        color: #7d7d7d;
        font-weight: bold;
        position: absolute;
        right: 40px;
        top: 50%;
        transform: translateY(-50%);

        &:hover {
          cursor: pointer;
          color: #222222;
        }
      }

      .esp_close_btn {
        right: 12px;
      }
    }

    .el-dialog__body {
      padding: 10px 5px 10px 10px;
      height: calc(100% - 98px);

      .el-scrollbar__view {
        padding-right: 15px;
      }
    }

    .el-dialog__footer {
      box-sizing: border-box;
      padding: 5px 10px 10px 10px;
      border-top: 1px solid #f5f5f5;

      .el-button {
        margin-left: 10px;
      }
    }

    &.esp_not_footer {
      .el-dialog__body {
        height: calc(100% - 34px);
      }
    }
  }

  &.esp_clear_padding {
    .el-dialog {
      .el-dialog__body {
        padding: 0px;
        height: calc(100% - 78px);
      }

      .el-scrollbar__view {
        padding-right: 0px;
      }
    }
  }
}

.el-dialog__wrapper {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/EspElDialog.vue